export default "__VITE_ASSET__CWj1Mnj3__"